"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.Spacer = void 0;
require("./Spacer.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Spacer component
 *
 * @method
 * @param { SpacerProps} props
 * @returns Spacer
 */

const Spacer = props => {
  const {
    spacerValue
  } = props;
  if (!spacerValue) {
    return null;
  }
  const componentClassName = (0, _classnames.default)('pal-c-Spacer', {
    [`pal-c-Spacer--${spacerValue}`]: spacerValue
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  });
};

/**
 * Property type definitions
 * @typedef SpacerProps
 * @type {object}
 * @property {string} spacerValue - Sets the spacing value
 */
exports.Spacer = Spacer;
const propTypes = exports.propTypes = {
  /**
   * Sets the spacing value
   */
  spacerValue: _propTypes.default.string
};
Spacer.propTypes = propTypes;
var _default = exports.default = Spacer;